import { render, staticRenderFns } from "./app-lastUpdate.vue?vue&type=template&id=b1a4ec78"
import script from "./app-lastUpdate.vue?vue&type=script&lang=js"
export * from "./app-lastUpdate.vue?vue&type=script&lang=js"
import style0 from "./app-lastUpdate.vue?vue&type=style&index=0&id=b1a4ec78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports